module.exports = __webpack_public_path__ + "static/media/rose-s.e12de721.svg";